<template>
    <div>
        <div class="modal-mask" role="dialog">
            <div class="overlay-mask">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div class="row g-py-20 g-px-20">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <p class="contract-label">Thank you for accepting the new contract!</p>
                                    <p class="contract-description">
                                        <a href="#" v-on:click="GeneratePdf()">Click here</a>
                                        <span v-if="isContractLoading">
                                                <img src="../../../static/img/loading.gif" style="width: 25px"/>
                                        </span>
                                        to download a copy for your records.                                    </p>
                                    <p class="contract-description">You can always view and download your current contract in your My Account Page</p>
                                </div>
                               <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                                    <button v-on:click="Login()" v-bind:disabled="isLoading" class="btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-10">
                                        Proceed to Home Page <span v-if="isLoading"><img src="../../../static/img/loading.gif" style="width: 25px"/></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: {},
        data(){
            return{
                Account:{
                    EmailAddress:null,
                    Password:null
                },
                isLoading: false,
                isContractLoading: false,
                isAwaitingActivation: "false"
            }
        },
        methods: {
            Login(){
                var _this = this;
                _this.isLoading = true;
                console.log("Contract update ACCT STATUS: ");
                console.log(this.accountStatus);
                if (this.accountStatus != "Active") {
                    _this.$router.push({name: 'Home'});
                    _this.isLoading = false;
                }
                else {
                    axios.post('/Auth/TryRequestToken', this.Account)
                    .then(function (response) {
                        if(response.data.isSuccess == true){
                            _this.isLoginfalse = false;
                            // localStorage.setItem("host", response.data.raw.username);
                            // localStorage.setItem("token", response.data.raw.token);
                            // localStorage.setItem("watchword", response.data.raw.password);
                            // localStorage.setItem("accountStatus", response.data.raw.accountStatus);
                            // _this.$router.push({name: 'PortalHome'});
                        }
                        localStorage.removeItem('email');
                        localStorage.removeItem('accountType');
                        localStorage.removeItem('isCoveredUnderHIPAA');
                        localStorage.removeItem('firstName');
                        localStorage.removeItem('lastName');
                        localStorage.removeItem('password');
                        _this.G_ProcessLogin(response);
                    })
                    .catch(function (error) {
                        _this.$router.push({name: 'Home'});
                        _this.$router.push({name: 'Error'});
                    });
                }
            },
            GeneratePdf() {
                var _this = this;
                _this.isContractLoading = true;
                var salesforceId = _this.$route.params.salesforceId;
                axios.get("/Account/GetContractBySalesforceId/" + salesforceId, {
                headers: { Authorization: "Bearer " + localStorage.getItem("token") }
                })
                .then(function(response) {
                    var result = response.data.raw;
                    var link = document.createElement("a");
                    link.href = result;
                    link.target = "_blank";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    _this.isContractLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    _this.$router.push({name: 'Error'});
                });
            }
        },
        created(){
            this.Account.EmailAddress = localStorage.getItem("email");
            this.Account.Password = localStorage.getItem("password");
            this.accountStatus = localStorage.getItem("accountStatus");
        }
    }
</script>



// WEBPACK FOOTER //
// ContractAgreementModal.vue?6b96299d